module.exports = __webpack_public_path__ + "img/蜈蚣.f204cd02.jpg";